import {createStore} from "vuex";

import auth from "@/store/modules/auth";
import files from './modules/files';
import shortLinks from './modules/shortLinks';
import pastes from './modules/pastes';

export default createStore({
    modules: {
        auth,
        files,
        shortLinks,
        pastes,
    }
});
